import React from 'react';
import PrimaryNavigation, { PrimaryNavigationProps } from './PrimaryNavigation';
import PageHeader, { PageHeaderProps } from 'components/PageHeader/PageHeader';
import PageSubHeader, {
  PageSubHeaderProps,
} from 'components/PageHeader/PageSubHeader';

export type PrimaryNavigationLayoutProps = PrimaryNavigationProps & {
  header: PageHeaderProps;
} & { subHeader?: PageSubHeaderProps } & {
  subHeaderRef?: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
};

export default function PrimaryNavigationLayout({
  reviewTitle,
  reviewPath,
  reviewer,
  searchPath,
  logoPath = '/reviews',
  myDiscussionPath,
  header,
  subHeader,
  subHeaderRef,
  children,
}: PrimaryNavigationLayoutProps) {
  return (
    <>
      <PrimaryNavigation
        reviewTitle={reviewTitle}
        reviewPath={reviewPath}
        logoPath={logoPath}
        reviewer={reviewer}
        searchPath={searchPath}
        myDiscussionPath={myDiscussionPath}
      />
      <PageHeader
        headerText={header.headerText}
        backLink={header.backLink}
        rightContent={header.rightContent}
      />
      {subHeader && (
        <PageSubHeader ref={subHeaderRef} links={subHeader.links} />
      )}

      {children}
    </>
  );
}
